'use client';

import TemplateAction, { ThreadActionProps } from './thread-action';

/**
 * 会话中的任务模板操作组件
 * 1. 区分 process 场景和 last 场景
 * 2. process 场景下，展示已存在的模板
 * 3. last 场景下，区分新建和已存在的模板
 */

interface BaseProps extends ThreadActionProps {}

interface ProcessSceneProps extends BaseProps {
  scene: 'process';
}

interface LastSceneProps extends BaseProps {
  scene: 'last';
  enableCreateTemplate: boolean;
  agentStatus: string; // TODO 整理类型
  threadAuditStatus: AUDIT.ThreadAuditStatus;
  threadStopStatus: string; // TODO 改名
  templateUserMsgId: string;
}

type ThreadTemplateActionProps = ProcessSceneProps | LastSceneProps;

const ThreadTemplateAction = (props: ThreadTemplateActionProps) => {
  const { scene, data, ...rest } = props;
  const commonProps = {
    data,
    ...rest,
  };
  if (scene === 'process') {
    if (!data || data.hide) {
      return null;
    }
    return <TemplateAction {...commonProps} />;
  }

  if (scene === 'last') {
    const {
      enableCreateTemplate: _enableCreateTemplate = false,
      agentStatus,
      threadAuditStatus,
      threadStopStatus,
      templateUserMsgId,
    } = props;
    const enableCreateTemplate =
      _enableCreateTemplate &&
      agentStatus === 'idle' &&
      threadAuditStatus === 'normal' &&
      threadStopStatus === 'FULL_COMPLETED' &&
      !data;
    const existTemplate = data && !data.hide;
    if (!enableCreateTemplate && !existTemplate) {
      return null;
    }
    const templateData: TEMPLATE.Template = existTemplate
      ? data
      : {
          id: '',
          status: 'unstart',
          message_id: templateUserMsgId,
        };
    return <TemplateAction {...commonProps} data={templateData} />;
  }

  return null;
};

export default ThreadTemplateAction;
